import {
  faUser,
  faCalendarLines,
  faUsers,
  faHeart,
} from '@fortawesome/pro-light-svg-icons';
import type { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { DataTestIdEnum } from '@medprev-web-app/datatestid';

import type { BooleanFeatureName } from '@/feature-flags/consts/features.const';

export type MenuFeatureName = Extract<
  BooleanFeatureName,
  'newProfile' | 'newAppointments' | 'newDependents' | 'newFavorites'
>;

export interface FeatureMenuEntry {
  label: string;
  icon: IconDefinition;
  testId: (typeof DataTestIdEnum)[keyof typeof DataTestIdEnum];
  internalRoute: string;
}

export const FEATURE_MENU: Record<MenuFeatureName, FeatureMenuEntry> = {
  newProfile: {
    label: 'Perfil',
    icon: faUser,
    testId: DataTestIdEnum.ITEM_PROFILE,
    internalRoute: '/meu-perfil',
  },
  newAppointments: {
    label: 'Agendamentos',
    icon: faCalendarLines,
    testId: DataTestIdEnum.ITEM_APPOINTMENTS,
    internalRoute: '/agendamentos',
  },
  newDependents: {
    label: 'Dependentes',
    icon: faUsers,
    testId: DataTestIdEnum.ITEM_DEPENDENTS,
    internalRoute: '/dependentes',
  },
  newFavorites: {
    label: 'Favoritos',
    icon: faHeart,
    testId: DataTestIdEnum.ITEM_FAVORITES,
    internalRoute: '/favoritos',
  },
} as const;
